import React from 'react';
import { Pagination } from 'react-bootstrap';

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  // Don't render if there are no pages or only one page
  if (totalPages <= 1) {
    return null;
  }

  const paginationItems = [];

  // Previous button
  paginationItems.push(
    <Pagination.Prev
      key="prev"
      onClick={() => onPageChange(currentPage - 1)}
      disabled={currentPage === 1}
    />
  );

  // Determine which page numbers to show
  const maxVisiblePages = 3;
  let startPage, endPage;

  if (totalPages <= maxVisiblePages) {
    // Show all pages if total is less than max visible
    startPage = 1;
    endPage = totalPages;
  } else {
    // Calculate start and end page based on current page
    const pagesToShow = 3; // Show 5 page numbers around current
    const halfPages = Math.floor(pagesToShow / 2);

    if (currentPage <= halfPages + 1) {
      // Near the beginning
      startPage = 1;
      endPage = pagesToShow;
    } else if (currentPage >= totalPages - halfPages) {
      // Near the end
      startPage = totalPages - pagesToShow + 1;
      endPage = totalPages;
    } else {
      // In the middle
      startPage = currentPage - halfPages;
      endPage = currentPage + halfPages;
    }
  }

  // First page
  if (startPage > 1) {
    paginationItems.push(
      <Pagination.Item
        key={1}
        active={currentPage === 1}
        onClick={() => onPageChange(1)}
      >
        {1}
      </Pagination.Item>
    );

    // Ellipsis after first page
    if (startPage > 2) {
      paginationItems.push(
        <Pagination.Ellipsis key="ellipsis-start" disabled />
      );
    }
  }

  // Page numbers
  for (let number = startPage; number <= endPage; number++) {
    paginationItems.push(
      <Pagination.Item
        key={number}
        active={number === currentPage}
        onClick={() => onPageChange(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  // Ellipsis before last page
  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      paginationItems.push(
        <Pagination.Ellipsis key="ellipsis-end" disabled />
      );
    }

    // Last page
    paginationItems.push(
      <Pagination.Item
        key={totalPages}
        active={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
      >
        {totalPages}
      </Pagination.Item>
    );
  }

  // Next button
  paginationItems.push(
    <Pagination.Next
      key="next"
      onClick={() => onPageChange(currentPage + 1)}
      disabled={currentPage === totalPages}
    />
  );

  return <Pagination>{paginationItems}</Pagination>;
};

export default CustomPagination;
